import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyProductsDetail.vue?vue&type=template&id=bc96e14a"
import script from "./MoleculeEditionBillingAcademyProductsDetail.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyProductsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports